import { useCallback, useEffect, useState } from 'react';
import { businessesAPI } from '../services/businessesApi';
import { formatApiError } from '../../../utils/errorMessage';

export default function useBusinessBranding(businessId, { enabled = true } = {}) {
  const [branding, setBranding] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  const loadBranding = useCallback(async () => {
    if (!businessId || !enabled) return;
    try {
      setLoading(true);
      const response = await businessesAPI.getBranding(businessId);
      setBranding(response.data);
      setError('');
    } catch (err) {
      setError(formatApiError(err, 'Failed to load branding'));
    } finally {
      setLoading(false);
    }
  }, [businessId, enabled]);

  useEffect(() => {
    loadBranding();
  }, [loadBranding]);

  const saveBranding = useCallback(async (data) => {
    if (!businessId) return;
    await businessesAPI.saveBranding(businessId, data);
    await loadBranding();
  }, [businessId, loadBranding]);

  const uploadLogo = useCallback(async (file) => {
    if (!businessId) return;
    await businessesAPI.uploadLogo(businessId, file);
    await loadBranding();
  }, [businessId, loadBranding]);

  const removeLogo = useCallback(async () => {
    if (!businessId) return;
    await businessesAPI.deleteLogo(businessId);
    await loadBranding();
  }, [businessId, loadBranding]);

  return {
    branding,
    loading,
    error,
    refresh: loadBranding,
    saveBranding,
    uploadLogo,
    removeLogo
  };
}

